export default __webpack_public_path__ + "static/media/malaysia3.0a53aceb.jpg";